import React from "react";
import { RequestSettings } from "./types";
import UseAuthConfig from "./useAuthConfig";


const useRequestPendingUser = (): [RequestSettings, (settings: Partial<RequestSettings>) => void] => {
    const { protectedResources }: any = UseAuthConfig();
    const [reqRequests , setReqRequest] = React.useState({
        PageNumber:1,
        SearchText:'',
        Name:'',
        PerformanceType:'',
        SortOrder:1,
        PageSize:12,
        OrderBy:'',
        ParameterOne:'Requested,Rejected',
        ParameterTwo:'',
        ParameterThree:'Requested,Rejected',
        url: protectedResources.apiTodoList.endpoint,
        accessToken: localStorage.getItem('AccessToken')
    });
    
  const updateSettings = (settings: Partial<RequestSettings>) => {
    setReqRequest(prevSettings => ({ ...prevSettings, ...settings }));
  };

  return [reqRequests, updateSettings];
};

export default useRequestPendingUser;
